@for (badgeData of badges(); track badgeData.labelKey) {
  <span
    class="employee-financing-plan-badge"
    [class.employee-financing-plan-badge--multiple]="hasMultipleBadges()"
    [style.background-color]="backgroundColor(badgeData)"
    [style.color]="textColor(badgeData)"
  >
    {{ badgeData.labelKey | translate }}
  </span>
}
